<div class="radio-question" *ngIf="data.title !== undefined">
  <h5 [innerHTML]="data.title" *ngIf="data.title.length > 0"
      [ngClass]="{'default-text': !data.includeTitle}"></h5>
  <div class="extra-text" [innerHTML]="data.beforeText" *ngIf="data.beforeText && data.beforeText.length > 0"></div>
  <div class="question-block" *ngFor="let answer of data.answers">
    <div class="question-label radio"
         [ngClass]="{'selected': answer.value === valueSelected, 'disabled': !active}"
         (click)="onAnswerSelected(answer.value)">
      <i class="radio-icon"></i>
      <span [innerHTML]="answer.text"></span>
    </div>
  </div>
  <div class="extra-text" [innerHTML]="data.afterText" *ngIf="data.afterText && data.afterText.length > 0"></div>
</div>
